import { useState } from 'react';
import { Bell, BellOff } from 'lucide-react';
import {
  threadNotifyPermission,
  threadNotifySupported,
  isThreadNotifyEnabled,
  requestThreadNotifyPermission,
  setThreadNotifyEnabled,
} from '../lib/threadNotifications';

/**
 * Opt-in toggle for desktop notifications on PM posts in threads (per browser,
 * default off). Hidden when the browser has no Notification API.
 */
export function ThreadNotifyToggle() {
  const [enabled, setEnabled] = useState(isThreadNotifyEnabled);
  const [permission, setPermission] = useState(threadNotifyPermission);

  if (!threadNotifySupported()) return null;

  const blocked = permission === 'denied';
  const on = enabled && permission === 'granted';

  const toggle = async () => {
    if (enabled) {
      setThreadNotifyEnabled(false);
      setEnabled(false);
      return;
    }
    setThreadNotifyEnabled(true);
    setEnabled(true);
    setPermission(await requestThreadNotifyPermission());
  };

  return (
    <div className="flex items-center justify-end gap-2 text-xs text-ink-muted">
      {enabled && blocked && <span>Notifications are blocked in your browser settings.</span>}
      <label className="inline-flex cursor-pointer items-center gap-1.5">
        <input type="checkbox" className="h-3.5 w-3.5" checked={enabled} onChange={() => void toggle()} />
        {on ? <Bell className="h-3.5 w-3.5" aria-hidden /> : <BellOff className="h-3.5 w-3.5" aria-hidden />}
        Notify me when the PM replies
      </label>
    </div>
  );
}
